import {
  Text,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
} from '@chakra-ui/react';
import { Formik, Field, Form } from 'formik';

const TextField: React.FC<{
  name: string;
  label: string;
  formikProps: any;
  placeholder: string;
}> = ({ name, label, formikProps, placeholder }) => {
  return (
    <Field name={name}>
      {/* @ts-ignore */}
      {(fieldProps) => {
        console.log('debug fieldProps', fieldProps);
        return (
          <FormControl>
            <FormLabel flex={1} mb={0}>
              {label}:
            </FormLabel>
            <Input
              {...fieldProps}
              p={0}
              border="none"
              borderBottom="1px solid #000"
              borderRadius="0"
              value={formikProps.values[name]}
              placeholder={placeholder}
              isDisabled={formikProps.isSubmitting}
              onChange={(event) => {
                formikProps.setFieldValue(name, event.target.value);
              }}
              _focus={{
                borderColor: 'transparent',
                borderBottom: '1px solid #000',
                boxShadow: 'none',
              }}
            />
            {fieldProps.form.errors[name] && (
              <Text color="red" fontSize="xs" mt={1}>
                {fieldProps.form.errors[name]}
              </Text>
            )}
            <FormErrorMessage>{fieldProps.form.errors[name]}</FormErrorMessage>
          </FormControl>
        );
      }}
    </Field>
  );
};

export default TextField;
